// extracted by mini-css-extract-plugin
module.exports = {"project_list":"ProjectList_project_list__I61N_"};